module.exports = __webpack_public_path__ + "static/media/zip.8c8a619e.png";